import { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { LoadingProvider } from 'react-hot-loading'
import Routes from 'routes'
import themes from 'themes'
import NavigationScroll from 'layout/NavigationScroll'
import Loading from './ui-component/Loading'
import { prop } from 'ramda'
import { QueryClient, QueryClientProvider } from 'react-query'
import ErrorBoundary from './ErrorBoundary'
import useSentry from 'hooks/useSentry'
import { Toaster } from 'react-hot-toast'
import { Confirmer } from './Confirmer'
import Confirm from './ui-component/Confirm'
import ErrorScreen from './ui-component/ErrorScreen'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retryDelay: attemptIndex =>
                Math.min(1000 * 2 ** attemptIndex, 30000),
            retry: 0,
            staleTime: 1000 * 10, // cached for 10 seconds
        },
    },
})

export default function App() {
    const customization = useSelector(prop('customization'))

    useSentry()

    return (
        <StyledEngineProvider injectFirst>
            <ErrorBoundary fallback={ErrorScreen}>
                <ThemeProvider theme={themes(customization)}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Suspense fallback={<Loading />}>
                            <QueryClientProvider client={queryClient}>
                                <DndProvider backend={HTML5Backend}>
                                    <Routes />
                                </DndProvider>
                            </QueryClientProvider>
                        </Suspense>
                    </NavigationScroll>
                    <Confirmer ConfirmComponent={Confirm} />
                    <LoadingProvider loading={<Loading />} />
                </ThemeProvider>
            </ErrorBoundary>
            <Toaster
                toastOptions={{
                    className: 'toasterWrapper',
                }}
            />
        </StyledEngineProvider>
    )
}
